import {assets, json} from "p3";
import Tilemap from "./Tilemap";

export default class Tileset {
    constructor() {
        this._textures = {};
    }

    /**
     * @param {object} data
     * @returns {Tileset}
     * @constructor
     */
    static create(data) {
        const tileset = new Tileset();
        const tilesetArray = P3.utils.objectToArray(data);

        for (let i = 0, count = tilesetArray.length; i < count; ++i) {
            let temp = tilesetArray[i];
            
            const tilesetName = Tilemap.filenameFromPath(temp.source);

            const gid = temp.firstgid;

            try {
                temp = json(tilesetName);

                const tileArray = P3.utils.objectToArray(temp.tiles);
                for (let j = 0, count = tileArray.length; j < count; ++j) {
                    const tile = tileArray[j];
                    const imageName = Tilemap.filenameFromPath(tile.image);

                    const id = gid + tile.id;
                    tileset.setTexture(id, assets.texture(imageName));
                }
            } catch { }
        }
        return tileset;
    }

    /**
     * @param {number} id
     * @returns {PIXI.Texture}
     */
    getTexture(id) {
        if (this._textures[id]) {
            return this._textures[id];
        }
        return null;
    }

    /**
     * @param {number} id
     * @param {PIXI.Texture} texture
     * @returns {boolean}
     */
    setTexture(id, texture) {
        if (!this._textures[id]) {
            this._textures[id] = texture;
            return true;
        }
        return false;
    }
}